/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { MenuComponent } from '../../../assets/ts/components';
import { toAbsoluteUrl } from '../../../helpers';
import { useLayout } from '../../core';
import { Header } from './Header';
import { Topbar } from './Topbar';

export function HeaderWrapper() {
  const { pathname } = useLocation();
  const { classes, attributes } = useLayout();

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [pathname]);

  return (
    <div id="kt_header" className={clsx('header', classes.header.join(' '), 'align-items-stretch')} {...attributes.headerMenu}>
      <div className={clsx(classes.headerContainer.join(' '), 'd-flex align-items-stretch justify-content-between')}>
        {/* begin::Logo */}
        <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15">
          <Link to="/dashboard">
            <img alt="Logo" src={toAbsoluteUrl('https://static.ticimax.cloud/54992/uploads/editoruploads/3aynet.png')} className="h-35px" />
          </Link>
        </div>
        {/* end::Logo */}

        {/* begin::Wrapper */}
        <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          {/* begin::Navbar */}
          <div className="d-flex align-items-stretch" id="kt_header_nav">
            <Header />
          </div>

          <div className="d-flex align-items-stretch flex-shrink-0">
            <Topbar />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  );
}
